module.exports = __webpack_public_path__ + "img/traffic-sign-1.103c9af8.png";